import React, { useContext, useEffect, useState } from "react";
import ChartComponent from "../ProductDashboard/Charts/ChartComponent";
import { formatDate } from "../../utilities/CommonUtilities";
import { fetchDashboardDataHome } from "../ProductDashboard/DashboardUtils";
import { FetchDashboardDataRequest } from "../ProductDashboard/DashboardSerializer";
import { useNavigate } from "react-router-dom";
import ChartSkeleton from "../ProductDashboard/Charts/ChartSkeleton";
import { Helmet } from "react-helmet";
import { UserDashboardContext } from "../ProtectedRoute";
import LoadingComponent from "../Common/LoadingComponent";

const insights = [
  {
    name: "Mexico Election",
    img: "https://www.emalpha.com/wp-content/uploads/2024/05/164-600x308.jpg",
    text: "Election Overview and Political Climate: Mexico’s largest-ever election on June 2 includes presidential, legislative, and local positions…",
    date: "May 31, 2024",
    url: "https://www.emalpha.com/mexico-election-insight/",
  },
  {
    name: "South Africa Election",
    img: "https://www.emalpha.com/wp-content/uploads/2024/05/163.jpg",
    text: "South Africa’s May 29 election features a record 31 parties, with nearly 28 million registered voters and 15,000 candidates vying for 887 seats. The ruling ANC is expected to fall short of 50% support due to socio-economic issues…",
    date: "May 23, 2024",
    url: "https://www.emalpha.com/south-africa-election-insight/",
  },
  {
    name: "India Election Update",
    img: "https://www.emalpha.com/wp-content/uploads/2024/04/164-600x308.jpg",
    text: "Foreign Institutional Investors: Foreign portfolio investors have been selling Indian stocks and bonds, with April seeing outflows as elections started, contributing to a dip in foreign reserves by over USD 2.4 billion from a record high in March.",
    date: "May 16, 2024",
    url: "https://www.emalpha.com/india-election-update/",
  },
  {
    name: "India Election",
    img: "https://www.emalpha.com/wp-content/uploads/2024/04/164-600x308.jpg",
    text: "General Election: India, the world’s fifth largest and fastest-growing major economy, is undergoing a 44-day general election starting April 19, with nearly 970 million citizens eligible to vote.",
    date: "April 18, 2024",
    url: "https://www.emalpha.com/india-election/",
  },
  {
    name: "Turkey Municipal Elections",
    img: "https://www.emalpha.com/wp-content/uploads/2024/03/163-600x308.jpg",
    text: "Turkey’s municipal elections are attracting attention due to significant political implications, with over 61 million voters across 81 provinces choosing among 34 parties…",
    date: "March 28, 2024",
    url: "https://www.emalpha.com/turkey-municipal-elections/",
  },
];

const Home = () => {
  const today = new Date();
  const navigate = useNavigate();
  const { tabs } = useContext(UserDashboardContext);

  const dashboard_names = [
    "GEOPOLITICAL_V1",
    "GEOPOLITICAL_INDIA_V1",
    "SANDGLASS_SASB_DASHBOARD",
  ];
  const filterDate = {
    endDate: today.setDate(today.getDate()),
    startDate: today.setMonth(today.getMonth() - 1),
  };
  const [isLoading, setIsLoading] = useState(true);
  const [dashboardChartData, setDashboardChartData] = useState(null);

  useEffect(() => {
    getDashboardData();
  }, [tabs]);

  const getDashboardData = async () => {
    setIsLoading(true);

    const dashboards = tabs.filter((tab) => tab.name === "Dashboard")[0][
      "subTabs"
    ];
    if (!dashboardChartData && dashboards.length > 0) {
      const dashboardsDate = dashboards.slice(0, 3).map(async (dashboard) => {
        const dashboardName = dashboard.dashboardName;
        const today = new Date();
        const defaultEndDate = dashboard.default_end_date
          ? new Date(dashboard.default_end_date)
          : new Date(today) || new Date(today);
        today.setMonth(today.getMonth() - 1);
        const defaultStartDate = dashboard.default_end_date
          ? new Date(dashboard.default_start_date)
          : new Date(today) || new Date(today);

        const filterDate = {
          endDate: defaultEndDate,
          startDate: defaultStartDate,
        };

        const fetchDashboardDataRequest = new FetchDashboardDataRequest(
          dashboardName,
          filterDate
        );
        const dashboardData = await fetchDashboardDataHome({
          fetchDashboardDataRequest,
        });
        return {
          name: dashboard.name,
          data: dashboardData,
          dashboardName: dashboardName,
        };
      });
      const dashboardData = await Promise.all(dashboardsDate);
      setDashboardChartData(dashboardData);
      setIsLoading(false);
    }
  };

  const handleDashboardClick = (dashboard) => {
    navigate(`/dashboard?dashboard_name=${dashboard}`);
  };

  return (
    <div style={{ height: "100%" }}>
      <Helmet>
        <title>Home | EMAlpha</title>
      </Helmet>
      <div
        className="d-flex flex-row p-2 gap-4 align-items-center"
        style={{ height: "6%" }}
      ></div>
      <div
        className="p-3 bg-white rounded-4 overflow-y-auto"
        style={{ height: "94%", width: "100%" }}
      >
        <div
          className="flex flex-col px-2 shadow-lg rounded-3 text-dark-gray"
          style={{ height: "40%", width: "100%" }}
        >
          <div className=" px-2 pt-2 w-100 h4 ">Dashboards</div>
          <div
            className="flex flex-grow-1 w-100"
            style={{ height: "80%", width: "100%" }}
          >
            <div
              className=" d-flex flex-row p-2  w-100"
              style={{ height: "100%", width: "100%" }}
            >
              {isLoading ? (
                <div
                  className="d-flex flex-grow p-2 bg-custom m-1 shadow-lg rounded-3 border-2 border-primary w-100"
                  style={{ height: "100%" }}
                >
                  <LoadingComponent />
                </div>
              ) : (
                <>
                  {dashboardChartData !== null &&
                  dashboardChartData !== undefined ? (
                    dashboardChartData.map(
                      ({ name, data, dashboardName }, index) =>
                        data && (
                          <div
                            className="d-flex flex-grow p-2 bg-white m-1 shadow-lg rounded-3 border-2 border-primary w-100"
                            style={{ height: "100%" }}
                            key={index}
                          >
                            <div className="w-100 h-100 text-light-gray">
                              <div style={{ height: "10%" }}>
                                <div className="">{name} Dashboard</div>
                              </div>
                              <div
                                className="w-100 rounded-4"
                                style={{ height: "90%" }}
                                onClick={() =>
                                  handleDashboardClick(dashboardName)
                                }
                              >
                                {isLoading ? (
                                  <>
                                    <ChartSkeleton />
                                  </>
                                ) : (
                                  <>
                                    {" "}
                                    {data === null ||
                                    data === undefined ? null : (
                                      <ChartComponent
                                        dashboardName={name}
                                        dashboardChartData={data}
                                      />
                                    )}
                                  </>
                                )}
                              </div>
                            </div>
                          </div>
                        )
                    )
                  ) : (
                    <></>
                  )}
                </>
              )}
            </div>
          </div>
        </div>
        <div
          className="flex flex-col px-4 text-dark-gray mt-4"
          style={{ height: "60%" }}
        >
          <div className="h4 mt-2">Insights</div>
          <div className="row">
            {insights.map((insight, index) => (
              <div className="col-12 mb-4 p-2" key={index}>
                <div className="card">
                  <div className="row no-gutters">
                    <div className="col-md-4">
                      <img
                        src={insight.img}
                        className="card-img p-2 rounded-2"
                        alt={insight.name}
                      />
                    </div>
                    <div className="col-md-8">
                      <div className="card-body ">
                        <div className="  text-dark-gray ">
                          <p className="h4">{insight.name}</p>
                        </div>
                        <p
                          className=" "
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          <small className="text-light-blue ">
                            {insight.date}
                          </small>
                        </p>
                        <p className=" text-light-gray">{insight.text}</p>
                        <a
                          href={insight.url}
                          className="text-light-blue font-weight-bold"
                          style={{ fontSize: "16px", fontWeight: "bold" }}
                        >
                          Read More
                        </a>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            ))}
          </div>
        </div>
      </div>
    </div>
  );
};

export default Home;
